import React, { useState, useEffect } from 'react'

import { ConnectWebSocketForOverlay, SetSocketMessageHandler, ClearSocketMessageHandler, DisconnectWebSocket } from './../../utilities/BL/Zones'


const KaraokeCam = () => {
    const [camConfig, setCamConfig] = useState({
        showMic: false, showNotes: false, showText: false,
        micX: 100, micY: 100, micRotation: 0, micScale: 1,
        notesX: 800, notesY: 800, notesScale: 1,
        textX: 500, textY: 200, textScale: 1, customText: "¡Canta con nosotros!"
    });

    useEffect(() => {
        document.body.style.backgroundColor = 'transparent';
        document.documentElement.style.backgroundColor = 'transparent';
        const rootElement = document.getElementById('root');
        if (rootElement) rootElement.style.backgroundColor = 'transparent';

        const connect = async () => {
            await ConnectWebSocketForOverlay('karaoke', () => {}, () => {});
            SetSocketMessageHandler((message) => {
                if (message?.type?.toLowerCase() === 'karaoke' && message.data?.action === 'cam_config') {
                    setCamConfig(message.data.config);
                }
            });
        };
        connect();
        return () => { ClearSocketMessageHandler(); DisconnectWebSocket(); };
    }, []);

    return (
        <>
            <style>
                {`
                    @keyframes floatNotes {
                        0% { transform: translateY(0px) rotate(0deg); opacity: 0.8; }
                        50% { transform: translateY(-30px) rotate(15deg); opacity: 1; }
                        100% { transform: translateY(0px) rotate(0deg); opacity: 0.8; }
                    }
                    .floating-note { display: inline-block; animation: floatNotes 3s ease-in-out infinite; font-size: 4rem; text-shadow: 2px 2px 10px rgba(0,0,0,0.5); }
                    .floating-note-delay { animation-delay: 1.5s; font-size: 5rem; }
                `}
            </style>

            {/* MICRÓFONO */}
            {camConfig.showMic && (
                <div style={{
                    position: 'absolute', bottom: `${camConfig.micY}px`, right: `${camConfig.micX}px`,
                    // IMPORTANTE: Primero escalamos, luego rotamos
                    transform: `scale(${camConfig.micScale || 1}) rotate(${camConfig.micRotation}deg)`,
                    transformOrigin: 'bottom center', transition: 'all 0.15s ease-out', zIndex: 10
                }}>
                    <img src="/img/overlays/karaoke/microphone-five.png" alt="Mic" style={{ width: '200px', height: '600px', objectFit: 'contain', filter: 'drop-shadow(5px 5px 15px rgba(0,0,0,0.6))' }} />
                </div>
            )}

            {/* NOTAS MUSICALES INDEPENDIENTES */}
            {camConfig.showNotes && (
                <div style={{
                    position: 'absolute', bottom: `${camConfig.notesY}px`, right: `${camConfig.notesX}px`,
                    transform: `scale(${camConfig.notesScale || 1})`, transformOrigin: 'center center',
                    transition: 'all 0.15s ease-out', zIndex: 5
                }}>
                    <span className="floating-note">🎵</span>
                    <span className="floating-note floating-note-delay">🎶</span>
                </div>
            )}

            {/* TEXTO DINÁMICO INDEPENDIENTE */}
            {camConfig.showText && (
                <div style={{
                    position: 'absolute', bottom: `${camConfig.textY}px`, right: `${camConfig.textX}px`,
                    transform: `scale(${camConfig.textScale || 1}) rotate(-5deg)`, transformOrigin: 'center center',
                    transition: 'all 0.15s ease-out', zIndex: 6
                }}>
                    <h1 style={{
                        color: '#ffffff', fontSize: '5rem', fontWeight: '900', fontFamily: '"Arial Black", Impact, sans-serif',
                        textTransform: 'uppercase', WebkitTextStroke: '3px #000000', textShadow: '6px 6px 0px #ff0055', margin: 0, whiteSpace: 'nowrap'
                    }}>
                        {camConfig.customText || "¡CANTA CON NOSOTROS!"}
                    </h1>
                </div>
            )}
        </>
    );
};

export { KaraokeCam };